/** Pick the Bearer token for an API path (admin routes must use admin session). */
export function pickAuthToken(path?: string): string {
  if (typeof window === 'undefined') return '';

  const adminToken = localStorage.getItem('dev_admin_token') || '';
  const adminRole = (localStorage.getItem('dev_admin_role') || '').toLowerCase();
  const isAdminRole = adminRole === 'superadmin' || adminRole === 'basicadmin';
  const crmToken = localStorage.getItem('crm_token') || '';
  const ownerToken = localStorage.getItem('owner_token') || '';
  const isAdminPath = path ? /^\/api\/admin(\/|$)/.test(path) : false;

  if (isAdminPath && adminToken && isAdminRole) return adminToken;
  if (isAdminPath && adminToken) return adminToken;
  if (crmToken) return crmToken;
  if (ownerToken) return ownerToken;
  if (adminToken && isAdminRole) return adminToken;
  return adminToken || '';
}

export function clearNonAdminSessionTokens(): void {
  try { localStorage.removeItem('owner_token'); } catch {}
  try { localStorage.removeItem('crm_token'); } catch {}
}
